import { Component, OnInit, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SearchCriteria, SortService } from '../../util/sort.service';
import { ClientStatusService } from '../status/client-status.service';
import {IClient, IIssue, IClientServiceMap, IIssueDetail, IService, IIssueClientServiceMap} from '../../model/common.model';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatDivider } from '@angular/material/divider';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-status-dialog',
    standalone: true,
    templateUrl: './status-dialog.component.html',
    styleUrls: ['./status-dialog.component.scss'],
    imports: [ MatIcon, MatIconModule, MatDivider, CommonModule ]
})
export class StatusDialogComponent implements OnInit {
  dialogRef = inject<MatDialogRef<StatusDialogComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);
  private sortService = inject(SortService);
  private clientStatusSvc = inject(ClientStatusService);


  issue: IIssue = new IIssue();
  client: IClient;
  issueUpdates: IIssueDetail[] = [];
  serviceList: IService[] = [];  
  affectedServices: IClientServiceMap[] = [];
  clientServices: IClientServiceMap[] = [];
  issueClientServiceMapList: IIssueClientServiceMap[] = [];
  selectedClientId: string = null;

  constructor() {
      const data = this.data;

      this.issue = data['issue'];
      this.client = data['client'];
      this.issueClientServiceMapList  = data.issueClientServiceMapList;
      this.serviceList = data.serviceList;
      this.selectedClientId =  this.client.code;
      this.clientServices = data.clientServices;

    }

  ngOnInit() {
    this.getIssueDetails();
  }

  getIssueDetails=()=>{    
    this.clientStatusSvc.doGet(`issuedetails?issueId=${this.issue.issueId}`).subscribe( data => {     
        this.issueUpdates  = this.clientStatusSvc.sortArray(<any[]> data['Items'], 'createtime', 'desc');
        this.affectedServices = [];
        this.serviceList.forEach(service=>{
          const issuemap = this.issueClientServiceMapList.filter(value=>value.serviceId === service.serviceId);
          if(issuemap.length){
            this.affectedServices.push(this.clientServices.find(value=>value.serviceId === service.serviceId));
          }
        });        
      
    });
  }  

  sortArray(data:any[], sortColumn: string, sortDirection = 'asc'){
    const criteria: SearchCriteria = new SearchCriteria();
    criteria.sortColumn = sortColumn;
    criteria.sortDirection = sortDirection;
    return this.sortService.sort(criteria, data);
  }

  getClass = (name: string)=>{
    return this.clientStatusSvc.getClass(name);
  }

}

@Component({
    selector: 'app-service-detail-dialog',
    standalone: true,
    templateUrl: './service-detail-dialog.component.html',
    styleUrls: ['./status-dialog.component.scss'],
    imports: [ MatIcon, MatIconModule ]
})

export class ServiceDetailDialogComponent implements OnInit {
  dialogRef = inject<MatDialogRef<ServiceDetailDialogComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);


  serviceDescription: string;
  ngOnInit() {
    const data = this.data;

    this.serviceDescription = data['serviceDescription'];
  }
}
